import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=0c71b874&scoped=true"
import script from "./risk.vue?vue&type=script&lang=js"
export * from "./risk.vue?vue&type=script&lang=js"
import style0 from "./risk.vue?vue&type=style&index=0&id=0c71b874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71b874",
  null
  
)

export default component.exports